import { selector as $$ } from '../../utils/selector';

export class VisionToggle {
  constructor(el) {
    this.isOpen = false;

    this.$el = el;
    this.$head = $$('.js-visionToggle__head', el)[0];
    this.$pane = $$('.js-visionToggle__pane', el)[0];

    this.#init();
  }

  #init() {
    this.$el.addEventListener('click', this.#onToggle);
    this.$head.addEventListener('mouseenter', this.#onMouseenter);
    this.$head.addEventListener('mouseleave', this.#onMouseleave);
  }

  #onToggle = (e) => {
    e.preventDefault();
    this.isOpen ? this.#closePane() : this.#openPane();
  };

  #openPane() {
    this.isOpen = true;

    this.$el.classList.add('-open');
    this.$pane.removeAttribute('hidden');
  }

  #closePane() {
    this.isOpen = false;

    this.$el.classList.remove('-open');
    this.$pane.setAttribute('hidden', '');
  }

  #onMouseenter = () => {
    this.$el.classList.add('is-mouseover');
  };

  #onMouseleave = () => {
    this.$el.classList.remove('is-mouseover');
  };
}
